/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerCompanyAddressResource } from './';
import {
    FreelancerCompanyAddressResourceFromJSON,
    FreelancerCompanyAddressResourceFromJSONTyped,
    FreelancerCompanyAddressResourceToJSON,
} from './';
import type { JoinUmbrellaApplication } from './';
import {
    JoinUmbrellaApplicationFromJSON,
    JoinUmbrellaApplicationFromJSONTyped,
    JoinUmbrellaApplicationToJSON,
} from './';
import type { LegalPersonType } from './';
import {
    LegalPersonTypeFromJSON,
    LegalPersonTypeFromJSONTyped,
    LegalPersonTypeToJSON,
} from './';
import type { TaxesResource } from './';
import {
    TaxesResourceFromJSON,
    TaxesResourceFromJSONTyped,
    TaxesResourceToJSON,
} from './';
import type { VatStatus } from './';
import {
    VatStatusFromJSON,
    VatStatusFromJSONTyped,
    VatStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelanceCompanyBusinessDetailsResource
 */
export interface FreelanceCompanyBusinessDetailsResource {
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyBusinessDetailsResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyBusinessDetailsResource
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyBusinessDetailsResource
     */
    registrationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyBusinessDetailsResource
     */
    vatNumber?: string;
    /**
     * 
     * @type {FreelancerCompanyAddressResource}
     * @memberof FreelanceCompanyBusinessDetailsResource
     */
    address: FreelancerCompanyAddressResource;
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyBusinessDetailsResource
     */
    companyTypeId?: string;
    /**
     * 
     * @type {LegalPersonType}
     * @memberof FreelanceCompanyBusinessDetailsResource
     */
    legalPersonType?: LegalPersonType;
    /**
     * 
     * @type {boolean}
     * @memberof FreelanceCompanyBusinessDetailsResource
     */
    isUmbrella: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelanceCompanyBusinessDetailsResource
     */
    isSubcontractor: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelanceCompanyBusinessDetailsResource
     * @deprecated
     */
    isAgency?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyBusinessDetailsResource
     */
    umbrellaCompanyId?: string;
    /**
     * 
     * @type {JoinUmbrellaApplication}
     * @memberof FreelanceCompanyBusinessDetailsResource
     */
    joinUmbrellaApplication?: JoinUmbrellaApplication;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FreelanceCompanyBusinessDetailsResource
     */
    legalNotices: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof FreelanceCompanyBusinessDetailsResource
     */
    isVatExempted: boolean;
    /**
     * 
     * @type {VatStatus}
     * @memberof FreelanceCompanyBusinessDetailsResource
     */
    vatStatus?: VatStatus;
    /**
     * 
     * @type {boolean}
     * @memberof FreelanceCompanyBusinessDetailsResource
     */
    hasOngoingProjects: boolean;
    /**
     * 
     * @type {Array<TaxesResource>}
     * @memberof FreelanceCompanyBusinessDetailsResource
     */
    taxes: Array<TaxesResource>;
}

/**
 * Check if a given object implements the FreelanceCompanyBusinessDetailsResource interface.
 */
export function instanceOfFreelanceCompanyBusinessDetailsResource(value: object): value is FreelanceCompanyBusinessDetailsResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('isUmbrella' in value) || value['isUmbrella'] === undefined) return false;
    if (!('isSubcontractor' in value) || value['isSubcontractor'] === undefined) return false;
    if (!('legalNotices' in value) || value['legalNotices'] === undefined) return false;
    if (!('isVatExempted' in value) || value['isVatExempted'] === undefined) return false;
    if (!('hasOngoingProjects' in value) || value['hasOngoingProjects'] === undefined) return false;
    if (!('taxes' in value) || value['taxes'] === undefined) return false;
    return true;
}

export function FreelanceCompanyBusinessDetailsResourceFromJSON(json: any): FreelanceCompanyBusinessDetailsResource {
    return FreelanceCompanyBusinessDetailsResourceFromJSONTyped(json, false);
}

export function FreelanceCompanyBusinessDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelanceCompanyBusinessDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
        'vatNumber': json['vatNumber'] == null ? undefined : json['vatNumber'],
        'address': FreelancerCompanyAddressResourceFromJSON(json['address']),
        'companyTypeId': json['companyTypeId'] == null ? undefined : json['companyTypeId'],
        'legalPersonType': json['legalPersonType'] == null ? undefined : LegalPersonTypeFromJSON(json['legalPersonType']),
        'isUmbrella': json['isUmbrella'],
        'isSubcontractor': json['isSubcontractor'],
        'isAgency': json['isAgency'] == null ? undefined : json['isAgency'],
        'umbrellaCompanyId': json['umbrellaCompanyId'] == null ? undefined : json['umbrellaCompanyId'],
        'joinUmbrellaApplication': json['joinUmbrellaApplication'] == null ? undefined : JoinUmbrellaApplicationFromJSON(json['joinUmbrellaApplication']),
        'legalNotices': json['legalNotices'],
        'isVatExempted': json['isVatExempted'],
        'vatStatus': json['vatStatus'] == null ? undefined : VatStatusFromJSON(json['vatStatus']),
        'hasOngoingProjects': json['hasOngoingProjects'],
        'taxes': ((json['taxes'] as Array<any>).map(TaxesResourceFromJSON)),
    };
}

export function FreelanceCompanyBusinessDetailsResourceToJSON(value?: FreelanceCompanyBusinessDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'registrationNumber': value['registrationNumber'],
        'vatNumber': value['vatNumber'],
        'address': FreelancerCompanyAddressResourceToJSON(value['address']),
        'companyTypeId': value['companyTypeId'],
        'legalPersonType': LegalPersonTypeToJSON(value['legalPersonType']),
        'isUmbrella': value['isUmbrella'],
        'isSubcontractor': value['isSubcontractor'],
        'isAgency': value['isAgency'],
        'umbrellaCompanyId': value['umbrellaCompanyId'],
        'joinUmbrellaApplication': JoinUmbrellaApplicationToJSON(value['joinUmbrellaApplication']),
        'legalNotices': value['legalNotices'],
        'isVatExempted': value['isVatExempted'],
        'vatStatus': VatStatusToJSON(value['vatStatus']),
        'hasOngoingProjects': value['hasOngoingProjects'],
        'taxes': ((value['taxes'] as Array<any>).map((v) => TaxesResourceToJSON(v))),
    };
}

